
// stnads for the example videos displayed at landing page

import video1 from "../resources/videos/webingo_subscription1.mp4";
import video2 from "../resources/videos/webingo_subscription2.mp4";
import video3 from "../resources/videos/webingo_subscription3.mp4";
import video4 from "../resources/videos/webingo_subscription4.mp4";

export const videos = {
    video1,
    video2,
    video3,
    video4,
}